module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"employerRegistration":"Регистрация работодателя"}}')
  delete Component.options._Ctor
}
